export default __webpack_public_path__ + "static/media/whitenoise.30454ac1.png";